<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import ModalTrigger from "@/components/Interface/Modal/ModalTrigger.vue";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { CDN } from '@/models/cdn.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="CDN.spy(64,props.newsItem.contentData.imageCode)"
    :toast-text="t('news.types.spyTrained.title')"
  >
    <ModalTrigger type="spy" :data="{spyId: props.newsItem.contentData.id}" >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="CDN.spy(512,props.newsItem.contentData.imageCode)"
        :header="t('news.types.spyTrained.title')"
      >
        <span class="text-slate-300">{{ props.newsItem.contentData.name }}</span> {{ t('news.types.spyTrained.body') }}
      </NewsItemBaseStructure>
    </ModalTrigger>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>